module.exports = __webpack_public_path__ + "img/NKCLC-logo.a9ed7095.svg";